/**
 * Check if the browser is IE6-11
 *
 * @return bool
 */
const isIE = () => {
  if (
    navigator.userAgent.indexOf("MSIE") !== -1 ||
    navigator.appVersion.indexOf("Trident/") > 0
  ) {
    return true;
  }

  return false;
};

const markIeOnHtmlDataAttribute = () => {
    if (isIE() === true) {
        $("html").attr("data-internet-explorer", "");
    }
};

export { isIE, markIeOnHtmlDataAttribute };
